import React from 'react';
import { useSelector } from 'react-redux';
import { useWindowSize } from '@yme/common/hooks';
import { IndentWrapper } from '@yme/components/Separator';
import { HeroSectionYoutube } from '@yme/molecules/hero-section-youtube';
import { getRTL } from '@yme/selectors/common';
import { colorCoreBlack700 } from '@yme/tokens/colors';
import { HeroSectionContent } from './HeroSectionContent';
import { HeroSectionTheme } from './HeroSectionTheme';
import { HeroBannerStyled, HeroImageStyled } from './styled';
export function HeroSection(props) {
    const { backgroundImage, title, youtubeId, subtitle, description, button, isRemoveBottomIndent, startTime, } = props;
    const labels = {
        title,
        subtitle,
        description,
    };
    const isRightToLeft = useSelector(getRTL);
    const { isMobileView, isInfiniteDesktopView } = useWindowSize();
    const isVideoShowed = isInfiniteDesktopView && youtubeId;
    const isMobilePanelNeeded = isMobileView && (description || button?.text);
    if (!title || !backgroundImage?.src) {
        return null;
    }
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(HeroBannerStyled, { isRightToLeft: isRightToLeft },
            React.createElement(HeroImageStyled, { imageUrl: !isVideoShowed ? backgroundImage.src : '', srcSet: backgroundImage.srcSet },
                isVideoShowed && (React.createElement(HeroSectionYoutube, { videoId: youtubeId, preview: backgroundImage.src, startTime: startTime })),
                React.createElement(HeroSectionContent, { labels: labels, buttonSettings: button, isRightToLeft: isRightToLeft })),
            isMobilePanelNeeded && (React.createElement(HeroSectionTheme, { currentColorTheme: colorCoreBlack700, description: description, buttonSettings: button, isRightToLeft: isRightToLeft })))));
}
HeroSection.displayName = 'HeroSection_AEMComponent';
